import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdate() {
  const sorted = [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">最新更新</h2>
            <p className="text-sm text-foreground-500 mt-1">每日同步最新韩漫章节</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-400 hidden sm:inline">更新日期：{sorted[0]?.updateDate || ''}</span>
            <Link
              to="/category/all"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
            >
              全部漫画
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {sorted.slice(0, 9).map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-4 p-4 bg-background-100 hover:bg-primary-50/50 rounded-lg transition-all duration-200"
            >
              <div className="relative flex-shrink-0 w-20 h-28 rounded-md overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
                {comic.isNew && (
                  <div className="absolute top-1 left-1 px-1.5 py-0.5 bg-accent-500 text-background-50 text-[10px] font-medium rounded-full">
                    NEW
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                    {comic.description}
                  </p>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-xs text-primary-600 font-medium">
                    第{comic.chapters[0].number}话
                  </span>
                  <span className="text-[11px] text-foreground-400">
                    {comic.updateDate}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}